import { useEffect, useState } from "react";
import useArielle from "../hooks/useArielle";
import { FilledButton } from "../components/common/Button";
import useSessionStorage, { STORAGE_KEYS } from "../hooks/useSessionStorage";
import { EArielleProcessingType } from "../data_models/aiModels/enums";
import { AI_AGENT_ASSETS } from "../config/defaultAssetUrls";
const CreateNewProjectPage: React.FC = () => {

    const {
        requestProjectDefinition,
        isProcessing,
    } = useArielle();

    const { value: sessionData, setValue: setSessionData } = useSessionStorage(STORAGE_KEYS.CREATE_PROJECT, {});
    const [bubbleText, setBubbleText] = useState('');

    const [showContent, setShowContent] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setShowContent(true);
        }, 50);
    }, []);

    // input 
    const [briefDescription, setBriefDescription] = useState((sessionData as any)?.briefDescription || '');
    const [briefDescriptionCharacters, setBriefDescriptionCharacters] = useState((sessionData as any)?.briefDescriptionCharacters || 0);
    const minCharactersDescription = 100;

    const introductions: string[] = [
        "Hi everyone! I'm Arielle, your go-to gal for turning caffeine into productivity. What brilliant ideas do you have today that I can help brew?",
        "Greetings! I'm Arielle, the mastermind behind making deadlines less terrifying. Let's make your ideas shine brighter than my morning coffee!",
        "Hello! I’m Arielle, your friendly neighborhood project manager. I’m here to ensure your dreams don’t just stay dreams—let’s make them a reality, preferably before lunch!",
        "Hey there! I’m Arielle, the juggler of tasks and lover of spreadsheets. What project can I help you toss into the air today without it crashing down?",
        "Hi folks! I’m Arielle, the digital organizer who believes every great idea deserves a chance to sparkle. So, what creative gems do you have for me today?",
        "Greetings! I’m Arielle, your project manager extraordinaire, armed with a sense of humor and a to-do list. What can I tackle for you today?",
        "Hey there! I'm Arielle, your partner in productivity and occasional pun enthusiast. Let’s turn your ideas into reality—after all, every genius needs a sidekick!",
        "Hello! I’m Arielle, the project management ninja. I’m here to help you slice through confusion—what challenges can I help you conquer today?",
        "Hi everyone! I’m Arielle, your productivity partner, ready to tackle any project with a smile and a cup of coffee. What’s on your agenda today?",
        "Hello! I’m Arielle, your friendly project manager, here to help you navigate the wild world of deadlines and deliverables. Let’s make magic happen!"
    ];


    const handleBriefDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setBriefDescription(e.target.value);
        const relevantContent = e.target.value.replace(/<[^>]*>?/g, '').trim();
        setBriefDescriptionCharacters(relevantContent.length);
        setSessionData({
            briefDescription: e.target.value,
            briefDescriptionCharacters: relevantContent.length
        });
    }
    const onStart = () => {
        requestProjectDefinition(briefDescription, true);
    }

    useEffect(() => {
        setBubbleText(introductions[Math.floor(Math.random() * introductions.length)]);
    }, []);

    return (
        <div className="relative min-h-screen w-full overflow-hidden">
            {/* Blurred dots */}
            <div className="absolute top-0 left-0 w-64 h-64 rounded-full bg-primary-500/30 blur-3xl -z-10" />
            <div className="absolute -top-12 left-64 w-64 h-64 rounded-full bg-primary-700/25 blur-3xl -z-10" />
            <div className="absolute -bottom-10 -right-5 w-64 h-64 rounded-full bg-primary-500/20 blur-3xl -z-10" />
            <div className="absolute bottom-36 right-5 w-64 h-64 rounded-full bg-secondary-500/20 blur-3xl -z-10" />
            <div className="absolute bottom-12 left-12 w-48 h-48 rounded-full bg-primary-200/30 blur-3xl -z-10" />

            <div className={`p-4 max-w-7xl mx-auto py-24 sm:py-32 px-14 ${showContent ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}>

                <div className="flex flex-row items-center gap-4">
                    <div className="flex flex-col gap-14">
                        <h2 className="mt-2 text-5xl font-semibold tracking-tight text-gray-900 sm:text-6xl">Hello! I’m Arielle, here to bring your ideas to life.</h2>
                        <div className={`hidden md:block`}>
                            <textarea
                                className="w-full px-6 py-3 border-2 border-gray-300 rounded-3xl shadow-sm focus:outline-none bg-white focus:ring-primary focus:border-primary hover:bg-primary-50 resize-none"
                                value={briefDescription}
                                onChange={handleBriefDescriptionChange}
                                rows={3}
                                placeholder="Tell us about your idea or project"
                            />
                            <div className="flex flex-row w-full justify-end">
                                <span className="caption2">{briefDescriptionCharacters}</span>
                                <span className="ml-1 caption2">
                                    (Min. {minCharactersDescription} characters)
                                </span>
                            </div>
                            <div className="mt-5 flex flex-row w-full justify-end">
                                <FilledButton
                                    onClick={onStart}
                                    disabled={briefDescriptionCharacters < minCharactersDescription}
                                    isLoading={isProcessing.has(EArielleProcessingType.CREATE_PROJECT_DETAILS)}
                                >Start
                                </FilledButton>
                            </div>

                        </div>
                    </div>
                    {/* Arielle  */}

                    <img src={AI_AGENT_ASSETS.ARIELLE_HALF_BODY_AVATAR} alt="Arielle" className="h-[500px]" />
                </div>

                <div className="h-1 bg-gradient-to-b from-primary-500 via-transparent to-transparent bg-gradient-to-l from-opacity-0 via-opacity-0 to-opacity-100 -mx-14 md:mx-0" />

                <div className={`md:hidden mt-10 ${showContent ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}>
                    <textarea
                        className="w-full px-6 py-3 border-2 border-gray-300 rounded-3xl shadow-sm focus:outline-none bg-white focus:ring-primary focus:border-primary hover:bg-primary-50 resize-none"
                        value={briefDescription}
                        rows={5}
                        onChange={handleBriefDescriptionChange}
                        placeholder="Tell us about your idea or project"
                    />
                    <div className="flex flex-row w-full justify-end">
                        <span className="caption2">{briefDescriptionCharacters}</span>
                        <span className="ml-1 caption2">
                            (Min. {minCharactersDescription} characters)
                        </span>
                    </div>
                    <div className="mt-5 flex flex-row w-full justify-center">
                        <FilledButton
                            onClick={onStart}
                            fullWidth
                            disabled={briefDescriptionCharacters < minCharactersDescription}
                            isLoading={isProcessing.has(EArielleProcessingType.CREATE_PROJECT_DETAILS)}
                        >Start
                        </FilledButton>
                    </div>

                </div>
            </div>

            {/* Arielle Speech Bubble */}
        </div>
    );
};

export default CreateNewProjectPage;